import styled from 'styled-components'

export const AddButton = styled.button`
  background: ${props => props.theme.colors.text.primary};
  color: ${props => props.theme.colors.background.primary};
  border: none;
  padding: 0.625rem 0.875rem;
  border-radius: ${props => props.theme.radius.button};
  font-size: 0.875rem;
  font-weight: 500;
  font-family: ${props => props.theme.typography.fontFamily};
  cursor: pointer;
  transition: ${props => props.theme.transitions.button};
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.medium};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
